<template>
    <section class="film-grid">
        <div class="grid-cpt__filters">
            <div class="grid-cpt__filters__item" :class="{'is-active' : filter.slug == filterCurrent }" v-for="filter in terms" :key="filter.term_id" v-on:click="filterPosts(filter.slug)">
                {{ filter.name }}
            </div>
        </div>
        <transition-group name="fade" tag="div" class="grid-cpt" :class="{'is-filter': animationCheck}">
            <a 
                class="grid-cpt__item"
                v-bind:style="{ 'background-image': 'url(' + post.acf.background_image_archive.sizes.large + ')' }"
                :href="post.url" 
                :key="post.ID"
                @mouseover="videoPlay('video'+post.ID)"
                @mouseleave="videoPause('video'+post.ID)"
                v-for="(post, index) in filteredFilms.slice(0, postsNumer)"
                :class="widthClass(index)"
            >
                <video :id="'video'+post.ID" class="grid-cpt__item__video" preload="meta" loop muted playsinline :src="post.acf.hover_video_archive"></video>
                <div class="grid-cpt__item__title" v-html="post.acf.title_archive"></div>
            </a>
        </transition-group>
        <div class="grid-cpt__loadmore">
            <div class="grid-cpt__loadmore__btn" @click="postsNumer += postsPerPage" v-if="postsNumer < filteredFilms.length">Load more</div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Film',
    data() {
        return {
            postsPerPage: 7,
            postsNumer: 8,
            posts: [],
            terms: [],
            filterCurrent: 'all',
            animationCheck: false
        }
    },
    create: function() {
    },
    watch: {
    },
    methods: {
        videoPlay(item) {
            document.getElementById(item).play();

            document.getElementById(item).addEventListener("timeupdate", function() {
                if( this.currentTime >= 15 ) {
                    this.currentTime = 0;
                    this.play();
                }
            });
        },
        videoPause(item) {
            const vid = document.getElementById(item);
            vid.onplay = function() {
                vid.pause();
            };
        },
        widthClass(index) {
            // console.log(index);
            let count = this.filteredFilms.length,
                widthLast = index+1 % 10,
                widthClass = 'grid-cpt__item--';

            if( count % 10 && index+1 == count ) {
                if ( widthLast == 1 || widthLast == 4 || widthLast == 6 || widthLast == 9 ) {
                    widthClass += 'full';
                } else if ( widthLast == 2 ) {
                    widthClass += 'height';
                } else if ( widthLast == 7 ) {
                    widthClass += 'before-height';
                } else {
                    widthClass = '';
                }
            } else {
                widthClass = '';
            }

            return widthClass;
        },
        filterPosts(slug) {
            if( this.filterCurrent !== slug ) {
                this.filterCurrent = slug;
                this.animationCheck = true;
            }
        }
    },
    computed: {
        filteredFilms() {
            setTimeout(() => {
                this.animationCheck = false;
            }, 500);
            return this.posts
            .filter((posts) => {
                if ( this.filterCurrent == 'all' ) {
                    return true;
                } else {
                    if( posts.terms ) {
                        for (let iTerms = 0; iTerms < posts.terms.length; iTerms++) {
                            if( posts.terms[iTerms].slug == this.filterCurrent ) {
                                return posts.terms[iTerms].slug == this.filterCurrent;
                            }
                        }
                    }
                }
            });
        }
    },
    mounted() {
        this.axios.get('/wp-json/film/v1/post')
            .then(response => {
                this.posts = response.data;
            });
        
        this.axios.get('/wp-json/film/v1/terms')
            .then(response => {
                this.terms = response.data;
            });
	},
}
</script>

<style lang="scss" scoped>
.grid-cpt {
    position: relative;
    overflow: hidden;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>